module.exports = __webpack_public_path__ + "img/profile_pic.0989e611.svg";